import { CircleFlag } from 'react-circle-flags';

type Props = {
  countryCode: string;
};
const CountryFlag: React.FC<Props> = ({ countryCode }) => {
  return <CircleFlag countryCode={countryCode.toLowerCase()} width={30} />;
};
export default CountryFlag;
